const OVERRIDDEN_COMPONENTS_PREFIX = 'Overridden'

export const OverriddenComponentsConfig = {
  path: '~/components/genesis/overrides',
  global: true,
  prefix: OVERRIDDEN_COMPONENTS_PREFIX,
}

export enum OverriddenComponents {
  AppTopBar = `${OVERRIDDEN_COMPONENTS_PREFIX}AppTopbar`,
  AppSubMenu = `${OVERRIDDEN_COMPONENTS_PREFIX}AppSubMenu`,
  InviteMembersDialog = `${OVERRIDDEN_COMPONENTS_PREFIX}OrganizationDialogInviteMembersDialog`,
}
